//@ts-nocheck
import React, { Component, createContext, useEffect, useRef } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { useSelector , useDispatch } from 'react-redux';
import { addParticipant, newMessageRecieved, removeParticipant, setSocketConnectivity, setSocketInstance, engagementCreated } from '../redux/actions/chatActions';
import { createEngagementSuccess, createEngagement } from '../redux/actions/engagementActions';
import Socket from '../utils/socket';

export const SocketContext = createContext()



const SocketContextProvider = ({children})=>{

  const [socket,setSocket] = useState(null);
  const { user , chat , engagement } = useSelector(state=>state);
  
  const dispatch = useDispatch()
  useEffect(()=>{
    if(user?.data?.customerToken){
      Socket.refreshSocket()
      setSocket(Socket.getInstance())
      dispatch(createEngagement({sessionId:user?.data?.sessionId}))
    }
  },[user?.data?.customerToken])
  

  useEffect(()=>{
    if(!socket) return;
    let inst = Socket.getInstance()
    inst.removeAllListeners()
    inst.on('participantAdded',(message)=>{
      dispatch(addParticipant(message))
    })


    inst.on('participantDisconnected',(message)=>{
      dispatch(removeParticipant(message))
      
    })

    inst.on("message", (message) => {
      console.log(message);
      console.log(message.body.payload);
      if(message.body.payload) {
        setTimeout(() => {
          dispatch(newMessageRecieved(message))
        }, 100);
      } else {
        dispatch(newMessageRecieved(message))
      }
    });

    inst.on("engagementCreated", (message) => {
      dispatch(engagementCreated(message))
    });

    inst.on("connect", () => {
      dispatch(setSocketConnectivity(true))
      dispatch(setSocketInstance(Socket.getInstance()))
      setSocket(Socket.getInstance())
    });
    
    inst.on("disconnect", () => {
      dispatch(setSocketConnectivity(false))
    }); 

    inst.on("engagementCreated", (message) => {
      // dispatch(createEngagementSuccess(message))
    });

    return ()=>{
      if(!socket) return;
      inst.off("participantAdded")
      inst.off("participantDisconnected")
      inst.off("message")
      inst.off("connect")
      inst.off("disconnect")
    }
    
  },[socket?.id,setSocket])


  let contextValue = {
    isSocketConnected :chat.isSocketConnected,
    socket:chat.socketInstance,
    messages:chat.messages,
    participants:chat.participants,
    isBotConnected: chat.isBotConnected,
    engagementParam: chat.engagementParam,
  }
// console.log("chat.chat -------------------");
// console.log(chat);
  return (
    <SocketContext.Provider value={contextValue}>
      {children}
    </SocketContext.Provider>
   )

}

export default SocketContextProvider;